import {useEffect, useRef} from "@wordpress/element";
import {CardElement, CardNumberElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {useCreatePaymentMethod, useProcessCheckoutError, useProcessCheckoutSuccess} from "../hooks";
import {getBillingDetailsFromAddress} from '@wc-stripe/blocks-utils';
import CustomCardForm from "./components/custom-card-form";
import StripeCardForm from "./components/stripe-card-form";
import './components/bootstrap';
import './components/simple';

const LegacyCardElement = (
    {
        data,
        billing,
        emitResponse,
        eventRegistration,
        activePaymentMethod,
        shouldSavePayment
    }) => {
    const currentData = useRef({});
    const name = data.name;
    const gatewayId = data.gatewayId;
    const stripe = useStripe();
    const elements = useElements();
    const {
        billingAddress
    } = billing;

    const {
        onCheckoutSuccess,
        onCheckoutFail
    } = eventRegistration;

    useEffect(() => {
        currentData.current = {billingAddress};
    }, [billingAddress])

    const {
        events,
        clearPaymentMethodData
    } = useCreatePaymentMethod({
        name,
        gatewayId,
        emitResponse,
        billingAddress,
        shouldSavePayment,
        eventRegistration,
        activePaymentMethod
    });

    useProcessCheckoutSuccess({
        name,
        elementType: 'card',
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod
    });

    useProcessCheckoutError({
        emitResponse,
        subscriber: onCheckoutFail,
        messageContext: emitResponse.noticeContexts.PAYMENTS,
        clearPaymentMethodData
    });

    const {
        addCreatePaymentMethodData
    } = events;

    useEffect(() => {
        const unsubscribe = addCreatePaymentMethodData(() => {
            const {billingAddress} = currentData.current;
            const elType = data.customFormActive ? CardNumberElement : CardElement;
            const card = elements.getElement(elType);
            return {
                type: 'card',
                card,
                billing_details: getBillingDetailsFromAddress(billingAddress)
            }
        });

        return unsubscribe;
    }, [
        stripe,
        elements,
        addCreatePaymentMethodData
    ])

    const onChange = (event) => {
    }

    const onComplete = () => {
    };

    const Tag = data.customFormActive ? CustomCardForm : StripeCardForm;
    return (
        <div className='wc-stripe-card-container'>
            <Tag {...{data, billing, onChange, onComplete}}/>
        </div>
    );
}

export default LegacyCardElement;